import React from 'react';

const FormWrapper = function (props) {
  const {
    type, name, children, text, required
  } = props;

  return (
    <div className={`formElement type-${type}`}>

      {text ? <label htmlFor={name}>{required && (<span className="required">*</span>)}{text}</label> : <span />}
      {children}
    </div>
  );
};

export default FormWrapper;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormWrapper.js